import { RouterProvider } from 'react-router'
import { RepositoryProvider } from '@/data/repository-context'
import { AuthProvider } from './auth/auth-context'
import { router } from './router'

export function App() {
  return (
    <RepositoryProvider>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </RepositoryProvider>
  )
}
